module.exports = __webpack_public_path__ + "img/星盤_個人星盤.5e231230.png";